import React, { FC, useState } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import {
  GetUserSegmentsQuery,
  ManualNotificationsItemFragment,
  SegmentStatus,
  useGetUserSegmentsQuery,
} from 'api';
import { EmptyState, Loaders } from 'components';
import { useGetManualNotifications } from 'features/admin/hooks';
import { useNotify } from 'hooks';
import Create from '../components/Messages/Create';
import Edit from '../components/Messages/Edit';
import Scheduled from '../components/Messages/Scheduled';
import Sent from '../components/Messages/Sent';

import { MESSAGE_LIMIT } from '../constants';

const SCHEDULED_VARIABLES = {
  scheduled: true,
  data: { limit: MESSAGE_LIMIT },
};

const SENT_VARIABLES = {
  scheduled: false,
  data: { limit: MESSAGE_LIMIT },
};

const Messages: FC = () => {
  const notify = useNotify();
  const [editing, setEditing] = useState(false);
  const [itemForEditing, setItemForEditing] = useState(null);

  const scheduledQueryResult = useGetManualNotifications(SCHEDULED_VARIABLES);
  const sentQueryResult = useGetManualNotifications(SENT_VARIABLES);
  const segmentsQueryResult = useGetUserSegmentsQuery<GetUserSegmentsQuery>(
    { segment_status: SegmentStatus.Active },
    {
      onError: notify.queryError,
      initialData: {
        getUserSegments: [],
      },
    }
  );

  const { getUserSegments } = segmentsQueryResult.data;

  function handleDelete() {
    setItemForEditing(null);
    setEditing(false);
  }

  function handleEdit(item: ManualNotificationsItemFragment) {
    setEditing(true);
    setItemForEditing(item);
  }

  if (editing) {
    return (
      <Edit
        queryVariables={SCHEDULED_VARIABLES}
        segments={getUserSegments}
        item={itemForEditing}
        onEdit={() => setEditing(false)}
        onDelete={handleDelete}
      />
    );
  }

  if (!scheduledQueryResult.results && !sentQueryResult.results) {
    return (
      <Grid>
        <EmptyState name="messages" />
      </Grid>
    );
  }

  if (segmentsQueryResult.isLoading) {
    return <Loaders.Standard />;
  }

  return (
    <Grid container spacing={4}>
      <Grid xs={12}>
        <Create segments={getUserSegments} queryVariables={SCHEDULED_VARIABLES} />
      </Grid>

      <Grid xs={12}>
        <Scheduled queryResult={scheduledQueryResult} onEdit={handleEdit} />
      </Grid>

      <Grid xs={12}>
        <Sent queryResult={sentQueryResult} />
      </Grid>
    </Grid>
  );
};

export default Messages;
